export default __webpack_public_path__ + "static/media/applications_notariales.52dc22a1.svg";